import { useParams, useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import Card from '../components/Card'

const Meetup = () => {
  const { id } = useParams()
  const navigate = useNavigate()

  const nextSteps = [
    {
        id: 5,
        title: 'Directory of Attendees',
        subtext: ['Get in touch and collaborate with each other!'],
        icon: '👥',
        linkable: true,
        link: `/facilitators?meetupId=${id}`,
      },
    
    {
      id: 2,
      title: '5 Personalized Wellness Journeys',
      subtext: ['Five diverse archetypes. Five unique journeys. Infinite possibilities.'],
      icon: '🌱',
      linkable: true,
      link: `/meetup/${id}/personalized-journeys`,
    },
    {
        id: 1,
        title: 'Wellness Loop WhatsApp Group',
        subtext: ['To stay in touch with the community.', 'No spam. Announcements only.'],
        icon: '📱',
        linkable: true,
        link: 'https://chat.whatsapp.com/ESSiwYfHQnpFTxS4gk7CPl?mode=wwt',
        external: true,
      },
  ];

  const nextSteps2 = [
  {
    id: 6,
    title: 'Co-create the wellness collaborative',
    subtext: ['A collaborative space for wellness practitioners to connect, collaborate, and co-create.'],
    icon: '🤝',
    linkable: true,
    link: '/wellness-collaborative',
  },  {
    id: 3,
    title: 'Express Interest for Build3 Wellness Program',
    subtext: ['Eight week online wellness routine for 60+ entrepreneurs. Starting November 17th 2025.'],
    icon: '🚀',
    linkable: true,
    link: '/build3-interest',
  },
  {
    id: 4,
    title: 'Express Interest for Bloom in Green Festival',
    subtext: ['Curating 25+ workshops for 1500 people, Jan 16-18, 2026'],
    icon: '🌿',
    linkable: true,
    link: 'https://forms.gle/5519Lvub91wqyihN8',
    external: true,
    cta: 'Apply Now →'
  }]

  const handleCardClick = (step) => {
    if (step.linkable && step.link) {
      if (step.external) {
        window.open(step.link, '_blank', 'noopener,noreferrer')
      } else {
        navigate(step.link)
      }
    }
  }

  return (
    <div className="bg-cream min-h-screen py-8">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {/* Header */}
          <div className="text-center mb-6">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Connecting the <span className="text-primary-600">Circles</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              5th November 2025, Bangalore Creative Circus
            </p>
          </div>

          {/* Next Steps Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            <div className="text-center mb-8">
              {/* <p className="text-gray-600">
                Continue your wellness journey with these next steps
              </p> */}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
              {nextSteps.map((step, index) => (
                <motion.div
                  key={step.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.1 * index }}
                >
                  <Card
                    className={`h-full transition-all duration-300 flex flex-col ${
                      step.linkable
                        ? 'cursor-pointer hover:shadow-xl hover:scale-105'
                        : 'cursor-default'
                    }`}
                    delay={0.1 * index}
                  >
                    <div
                      {...(step.linkable && { onClick: () => handleCardClick(step) })}
                      className="flex flex-col h-full"
                    >
                      <div className="text-5xl mb-4 text-center">
                        {step.icon}
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">
                        {step.title}
                      </h3>
                      {step.subtext && (
                        <ul className="text-gray-600 text-sm text-center">
                          {step.subtext.map((item, index) => (
                            <li key={index}>{item}</li>
                          ))}
                        </ul>
                      )}
                      {step.linkable && (
                        <div className="mt-auto pt-4 text-center">
                          <span className="text-primary-600 text-sm font-medium">
                            {step.external ? 'Click to join →' : 'Click to view →'}
                          </span>
                        </div>
                      )}
                    </div>
                  </Card>
                </motion.div>
              ))}
            </div>
            <div className="text-center mt-8 mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-2">
                Next Steps
              </h2>
            </div>
            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
                {nextSteps2.map((step, index) => (
                    <motion.div
                        key={step.id}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.1 * index }}
                    >
                        <Card
                            className={`h-full transition-all duration-300 flex flex-col ${
                                step.linkable
                                    ? 'cursor-pointer hover:shadow-xl hover:scale-105'
                                    : 'cursor-default'
                            }`}
                            delay={0.1 * index}
                        >
                            <div
                                {...(step.linkable && { onClick: () => handleCardClick(step) })}
                                className="flex flex-col h-full"
                            >
                                <div className="text-5xl mb-4 text-center">
                                    {step.icon}
                                </div>
                                <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">
                                    {step.title}
                                </h3>
                                {step.subtext && (
                                    <ul className="text-gray-600 text-sm text-center">
                                        {step.subtext.map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                )}
                                {step.linkable && (
                                    <div className="mt-auto pt-4 text-center">
                                        <span className="text-primary-600 text-sm font-medium">
                                            {step.cta ? step.cta : (step.external ? 'Click to join →' : 'Click to view →')}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </Card>
                    </motion.div>
                ))}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  )
}

export default Meetup
